import { Environment } from '../config/environment';
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

/**
 * Sistema de navegación universal para Web, PWA y Android/iOS
 * Usa React Router cuando es posible, window.location cuando es necesario
 */

/**
 * Navega a una ruta interna de la aplicación
 * RECOMENDADO: Usar useNavigate() de react-router en lugar de esta función
 * Esta función es para casos especiales donde no se puede usar el hook
 */
export function navigateTo(path: string) {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  
  console.log(`[Navigation] ${Environment.getPlatform()} - navigating to:`, normalizedPath);
  
  if (Environment.isNative()) {
    // En Android/iOS, construir URL completa con capacitor://localhost
    const fullUrl = `${window.location.origin}${normalizedPath}`;
    console.log('[Navigation] Native platform, using window.location.replace:', fullUrl);
    window.location.replace(fullUrl);
  } else {
    // En web/PWA, navegación normal
    console.log('[Navigation] Web platform, using window.location.href');
    window.location.href = normalizedPath;
  }
}

/**
 * Recarga la página actual
 */
export function reloadPage() {
  console.log(`[Navigation] ${Environment.getPlatform()} - reloading page`);
  window.location.reload();
}

/**
 * Navega con replace (sin agregar al historial)
 */
export function replaceWith(path: string) {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  
  console.log(`[Navigation] ${Environment.getPlatform()} - replacing with:`, normalizedPath);
  
  if (Environment.isNative()) {
    const fullUrl = `${window.location.origin}${normalizedPath}`;
    window.location.replace(fullUrl);
  } else {
    window.location.replace(normalizedPath);
  }
}

/**
 * Abre una URL externa en el navegador
 * En Android/iOS abre el navegador del sistema
 */
export function openExternal(url: string) {
  console.log(`[Navigation] ${Environment.getPlatform()} - opening external:`, url);
  
  if (Environment.isNative() || Capacitor.isNativePlatform()) {
    // En Capacitor, abrir en navegador del sistema (evita ERR_UNKNOWN_URL_SCHEME en redirects tipo whatsapp://)
    Browser.open({ url }).catch(() => {
      window.open(url, '_system');
    });
  } else {
    // En web, abrir en nueva pestaña
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}

/**
 * Retorna la URL completa para una ruta (útil para links, emails, etc.)
 */
export function getFullURL(path: string): string {
  return Environment.getFullURL(path);
}

/**
 * Navega a una URL de pago externa (MercadoPago, Stripe, etc.)
 */
export function navigateToPayment(paymentUrl: string) {
  console.log(`[Navigation] ${Environment.getPlatform()} - navigating to payment:`, paymentUrl);
  
  // Pagos siempre abren en navegador, incluso en app nativa
  if (Environment.isNative()) {
    window.open(paymentUrl, '_system');
  } else {
    window.location.href = paymentUrl;
  }
}
